import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import axios from 'src/devias/utils/axios';

interface NotificationSliceState {
  notifications: any[];
}

const initialState: NotificationSliceState = {
  notifications: []
};

const slice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    getNotifications(state, action: PayloadAction<{ notifications: any[] }>) {
      const { notifications } = action.payload;

      state.notifications = notifications;
    }
  }
});

export const reducer = slice.reducer;

export const getNotifications = () => async (dispatch: any) => {
  const response = await axios.get('/api/notifications');

  dispatch(slice.actions.getNotifications(response.data));
};

export default slice;
